export interface CreateContactParameters {
  AccountId: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Telephone?: string;
  Position?: string;
}
